// @flow

import * as React from "react";
import SVG from "react-inlinesvg";
import { format } from "date-fns";
import userIcon from "../../assets/icons/other/user.svg";

import styles from "./Comment.scss";
import { dateTimeFormat } from "../../utils/formats";

type CommentProps = {
  author: string,
  content: () => React.Node,
  postDate: Date
};

const Comment = ({ author, content, postDate }: CommentProps) => (
  <div className={styles.container}>
    <span className={styles.author}>
      <SVG src={userIcon} className={styles.authorIcon} />
      {author}
    </span>
    <span className={styles.date}>{`${format(postDate, dateTimeFormat)} Uhr`}</span>
    <div className={styles.content}>{content()}</div>
  </div>
);

Comment.defaultProps = {
  content: () => null
};

export default Comment;
